<template>
  <div class="cart-totals">
    <div class="totals-heading">{{ $t('checkout.totalsHeading') }}</div>
    <checkout-cart-totals-row v-if="$props.recurringPrice" class="first-totals-row" :total-name="$t('checkout.totalRecurringPrice')" :note="$t('checkout.totalRecurringPriceNote')">
      <product-price :price="$props.recurringPrice" :currency="$props.currency || $t('common.currency')" size="md"/>
    </checkout-cart-totals-row>
    <checkout-cart-totals-row v-if="$props.buyoutPrice" :total-name="$t('checkout.buyoutPrice')">
      <product-price :price="$props.buyoutPrice" :currency="$props.currency || $t('common.currency')" size="md"/>
    </checkout-cart-totals-row>
    <checkout-cart-totals-row :total-name="$t('checkout.totalPrice')" cart-total>
      <div v-if="isFreeESimSrb && $props.totalPrice === '0,00'" class="free-e-sim-label">{{ $t('checkout.free') }}</div>
      <product-price v-else :price="$props.totalPrice" :currency="$props.currency || $t('common.currency')" size="lg"/>
    </checkout-cart-totals-row>
  </div>
</template>

<script>
import CheckoutCartTotalsRow from './checkout-cart-totals-row'
import ProductPrice from '../../common/product-price'

export default {
  name: 'checkout-cart-totals',
  components: { ProductPrice, CheckoutCartTotalsRow },
  props: {
    recurringPrice: [String, Number],
    totalPrice: [String, Number],
    currency: String,
    buyoutPrice: String,
    isFreeESimSrb: {
      type: Boolean,
      required: false,
      default: false
    }
  }
}
</script>

<style scoped lang="scss">
.cart-totals {
  margin: 4rem 0;

  .totals-heading {
    background-color: $primary;
    border-radius: 0.5rem 0.5rem 0 0;
    color: $white;
    padding: 0.8rem 2.4rem 1.3rem;
    font-size: 1.4rem;
    font-weight: 600;
    text-transform: uppercase;
    margin-bottom: -0.5rem;
  }

  .first-totals-row {
    border-radius: 0.5rem 0.5rem 0 0;
  }

  &.for-tourist .product-price {
    text-align: end;
  }
  .free-e-sim-label {
    text-align: right;
    font-weight: 500;
  }
}
</style>
